export const bannerTextContainerClasses = 'h-fit rounded bg-accent p-1 text-xs font-medium text-surface sm:mt-0';
